import React from 'react';

export default class Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Step 4 – Establish your core
                                                dimension(s)
                                            </div>
                                            <p>Using the checklist, identify which dimensions you have ticked
                                                the most. These are likely to be core ‘drivers’ that will shape
                                                your approach to work and your typical behaviour. The table
                                                below provides some points to consider for each dimension:</p>

                                            <table className="ilead_v_sport " border="0" cellPadding="0"
                                                   cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve " align="left" valign="top"
                                                        width="20%">Dimension
                                                    </th>
                                                    <th className=" green_curve1" align="left" valign="top"
                                                        width="80%">Considerations
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <td className="lightgreen paddingcenter" align="left"
                                                        valign="top" width="20%">
                                                        <div className="paddingcenter">Reward or recognition
                                                        </div>
                                                    </td>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="80%">
                                                        <ul className="greenbullet-list">

                                                            <li>You’re likely to be motivated to have a secure
                                                                financial income or by receiving ‘just’ reward
                                                                or recognition for your work.
                                                            </li>
                                                            <li>You are someone who will value a reward-based
                                                                system and feel that people should be recognised
                                                                for the effort they make.
                                                            </li>
                                                            <li>Consider whether the environment in which you
                                                                currently work caters for your need to be
                                                                rewarded or recognised.
                                                            </li>


                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%">
                                                        <div className="paddingcenter ">Role content</div>
                                                    </td>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="80%">
                                                        <ul className="greenbullet-list">

                                                            <li>You’re likely to be specific about the type of
                                                                role which you take on.
                                                            </li>
                                                            <li>You would probably prefer it if your job related
                                                                to your experience.
                                                            </li>
                                                            <li>Consider whether the environment in which you
                                                                currently work caters for your need to use your
                                                                knowledge in your role and to enjoy the type of
                                                                work that you do.
                                                            </li>


                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <div className="paddingcenter">Social aspects</div>
                                                    </td>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="80%">
                                                        <ul className="greenbullet-list">

                                                            <li>You’re likely to be motivated to do a job that
                                                                has some benefits for the wider community.
                                                            </li>
                                                            <li>You may enjoy the social side of the working
                                                                environment and are motivated to work with other
                                                                people.
                                                            </li>
                                                            <li>Consider whether the environment in which you
                                                                currently work caters for your need to see the
                                                                social side of your job and the wider benefits
                                                                to the community.
                                                            </li>


                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%">
                                                        <div
                                                            className="paddingcenter extrapaddingtable">Personal
                                                            development
                                                        </div>
                                                    </td>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="80%">
                                                        <ul className="greenbullet-list">

                                                            <li>You’re motivated by learning and development and
                                                                it’s probably important for you to be
                                                                continuously developing in your role.
                                                            </li>
                                                            <li>You may benefit from working in an environment
                                                                where experience, mistakes and successes are
                                                                learned from. You may enjoy a role where there
                                                                is a structured career path.
                                                            </li>
                                                            <li>Consider whether the environment in which you
                                                                currently work caters for your need to grow and
                                                                develop and meets your ambitions and goals.
                                                            </li>


                                                        </ul>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>

                                            <p>You should now have a better idea of your values and preferences
                                                and what you really want from your working environment.</p>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Example</div>
                                                <p>Consider the following example of someone completing steps
                                                    1-4:</p>
                                                <p><span className="subtiltereg">Values identified:</span> Hard
                                                    work, integrity, work ethic, family.</p>
                                                <p><span
                                                    className="subtiltereg">Preferences identified:</span> Works
                                                    well with others, likes to be busy, gets the job completed,
                                                    complies with rules, will take calculated risks.</p>
                                                <p><span
                                                    className="subtiltereg">Dimensions identified:</span> reward
                                                    or recognition and social aspects.</p>
                                            </div>

                                            <p>This person’s values seem to be linked to their preferences and
                                                dimensions. Two themes seem to emerge: importance of a social
                                                aspect and the value of hard work. However this does require
                                                further exploration.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page7')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}